import { ConfirmationModal } from '@/components/core/confirmation-modal/confirmation-modal';
import { useDeleteAgentById } from '@/modules/gpt-chats/hooks/use-agents';
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

type DeleteAgentProps = {
  agentId: string;
  open: boolean;
  onOpenChange: (value: boolean) => void;
};

export const DeleteAgent = ({ agentId, open, onOpenChange }: DeleteAgentProps) => {
  const { mutateAsync } = useDeleteAgentById();
  const { toast } = useToast();
  const { t } = useTranslation();

  const confirmHandler = async () => {
    try {
      const res = await mutateAsync({
        agent_id: agentId,
      });
      if (!res.is_success) {
        return toast({
          title: t('ERROR'),
          description: res.detail || t('FAILED_TO_DELETE_AGENT'),
          variant: 'destructive',
        });
      }
      toast({
        title: t('SUCCESS'),
        description: t('AGENT_DELETED_SUCCESSFULLY'),
        variant: 'success',
      });
    } catch (error) {
      return toast({
        title: t('ERROR'),
        description: t('SOMETHING_WENT_WRONG'),
        variant: 'destructive',
      });
    }
  };

  return (
    <ConfirmationModal
      open={open}
      onOpenChange={onOpenChange}
      title={t('DELETE_AGENT')}
      description={t('DELETE_AGENT_CONFIRMATION_SUBTITLE')}
      onConfirm={confirmHandler}
      onCancel={() => onOpenChange(false)}
      confirmText={t('DELETE')}
      cancelText={t('CANCEL')}
    />
  );
};
